<template>
	<div class="page">
		<Tip :tip="tip" />
		<el-row :gutter="20" style="margin-top: 20px;">
			<el-col :span="6">
				<el-card shadow="always">
					<span class="title">本月经营</span>
					<el-row>
						<el-col class="item" :span="12">
							<span class="dec">{{statistics.operation.consumer_new || 0}}</span>
							<span class="name">新建客户档案</span>
						</el-col>
                        <el-col class="item" :span="12">
							<span class="dec">{{statistics.operation.contract || 0}}</span>
							<span class="name">业务合同</span>
						</el-col>
                        <el-col class="item" :span="12">
							<span class="dec">{{statistics.operation.good_new || 0}}</span>
							<span class="name">新增库商品</span>
						</el-col>
                        <el-col class="item" :span="12">
							<span class="dec">{{statistics.operation.income_amount || 0}}</span>
							<span class="name">业务收款</span>
						</el-col>
					</el-row>
					<el-divider />
					<el-row>
						<el-col class="item" :span="12">
							<span class="dec">{{statistics.operation.consumer_count || 0}}</span>
							<span class="name">客户档案总数</span>
						</el-col>
                        <el-col class="item" :span="12">
							<span class="dec">{{statistics.operation.good_count || 0}}</span>
							<span class="name">商品库商品</span>
						</el-col>
					</el-row>
				</el-card>
			</el-col>
			<el-col :span="18">
				<el-card shadow="always">
					<div class="chart" id="chart"></div>
				</el-card>
			</el-col>
		</el-row>
		<div class="screen_div">
            <el-select class="select" v-model="screen.created_by" clearable placeholder="创建人" @visible-change='selectAdmin'>
				<el-option :key="0" label="全部" :value="0" />
				<el-option v-for="item in adminList" :key="item.admin_id" :label="item.nick_name" :value="item.admin_id" />
			</el-select>
            <el-date-picker class="picker" v-model="screen.created_time" type="datetimerange"
				value-format="yyyy-MM-dd HH:mm:ss" range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间"
				placeholder="合同时间范围" />
            <el-select class="select" v-model="screen.consumer_id" clearable placeholder="客户名称" @visible-change='selectConsumer'>
                <el-option v-for="item in consumerList" :key="item.consumer_id" :label="item.consumer_name" :value="item.consumer_id" />
            </el-select>
			<el-button type="info" @click="getprocurementContractList">筛选</el-button>

            <span style="margin: 10px 0 0 20px;">合计：业务金额{{accumulate.procurement_amount || 0}}元，支出{{accumulate.outcome || 0}}元，回款{{accumulate.intcome || 0}}元，提成{{accumulate.commission || 0}}，毛利{{accumulate.profile || 0}}元</span>
		</div>
		<el-table class="table_div" :data="tableData" :loading="loading" :header-cell-style="tabStyle">
			<el-table-column label="制单业务员" width="200">
				<template slot-scope="scope">
					<span>{{scope.row.admin.nick_name}} {{scope.row.admin.phone}}</span>
				</template>
			</el-table-column>
			<el-table-column label="客户单位/合同名称">
				<template slot-scope="scope">
					<div class="col">
						<span>{{scope.row.consumer.consumer_name}}</span>
						<span>{{scope.row.procurement_id}} {{scope.row.procurement_name}}</span>
					</div>
				</template>
			</el-table-column>
			<el-table-column label="商品数">
				<template slot-scope="scope">
					<span>{{scope.row.procurement_quatity}}</span>
				</template>
			</el-table-column>
			<el-table-column label="业务金额">
				<template slot-scope="scope">
					<span>{{scope.row.procurement_amount}}</span>
				</template>
			</el-table-column>
			<el-table-column label="支出">
				<template slot-scope="scope">
					<span>{{scope.row.outcome}}</span>
				</template>
			</el-table-column>
			<el-table-column label="回款">
				<template slot-scope="scope">
					<span>{{scope.row.income}}</span>
				</template>
			</el-table-column>
			<el-table-column label="提成">
				<template slot-scope="scope">
					<span>{{scope.row.commission}}</span>
				</template>
			</el-table-column>
			<el-table-column label="毛利">
				<template slot-scope="scope">
					<span>{{scope.row.profile}}</span>
				</template>
			</el-table-column>
			<el-table-column label="状态" width="100">
				<template slot-scope="scope">
					<span>{{scope.row.state_text}}</span>
				</template>
			</el-table-column>
			<!-- <el-table-column label="操作" width="100">
				<template slot-scope="scope">
					<el-button size="mini" type="primary">查看</el-button>
				</template>
			</el-table-column> -->
		</el-table>
		<div class="foot_div">
			<!--分页按钮-->
			<el-pagination class="pagination" background layout="prev, pager, next,jumper, ->, total" :total="total"
				@current-change="handleCurrentChange" :currentPage="screen.page" :pageSize="screen.limit">
			</el-pagination>
		</div>
	</div>
</template>

<script>
	import Tip from "../../../components/Tip/Tip.vue"
	var echarts = require('echarts');
    import {
        consumerLists,
        adminLists,
        procurementContractList,
        indexStatistics
	} from "../../../request/apis.js"
	export default {
		components: {
			Tip
		},
		data() {
			return {
				tip: '公司业务概况，及业务状态。',

                screen: {
                    created_by: '',
                    created_time: [],
                    consumer_id: '',
                    page: 1,
                    limit: 10,
                },
                adminList: [],
                consumerList: [],
				value: [],
                loading: false,
				tableData: [],
                total: 0,
                accumulate: {},
                statistics: {
                    operation: {},
                    submit_time: [],
                    graph: []
                }
			}
		},
		computed: {
			tabStyle() {
				return {
					background: '#f5f5f5',
					color: '#333',
				}
			}
		},
		mounted() {
            this.getindexStatistics();
            this.getprocurementContractList();
		},
		methods: {
            async getindexStatistics(){
                const res = await indexStatistics()
                if (res.code) {
                    return this.$message.error(res.msg)
                }
                this.statistics = res.data;
                this.echartsInit();
            },
            async getprocurementContractList(){
                this.loading = true;
                const res = await procurementContractList(this.screen);
                this.loading = false;
                if (res.code) {
                    return this.$message.error(res.msg)
                }
                this.tableData = res.data;
                this.total = res.count;
                this.accumulate = res.other.accumulate;
            },

            handleCurrentChange(page) {
				this.screen.page = page; //每次点击分页按钮，当前页发生变化
				this.getprocurementContractList();
			},

            async selectAdmin(query){
                if (!query) {
                    return false;
                }
                const res = await adminLists()
                if (res.code) {
                    return this.$message.error(res.msg)
                }
                this.adminList = res.data;
            },

            async selectConsumer(query){
                if (!query) {
                    return false;
                }
                const res = await consumerLists()
                if (res.code) {
                    return this.$message.error(res.msg)
                }
                this.consumerList = res.data;
            },
			
			//曲线图
			echartsInit() {
                var submitDateArr = [];
                var orderCountArr = [];
                var orderAmountArr = [];

                this.statistics.graph.forEach(item => {
                    submitDateArr.push(item.submit_date);
                    orderCountArr.push(item.order_count);
                    orderAmountArr.push(item.order_amount);
                });

				var chartDom = document.getElementById('chart');
				var myChart = echarts.init(chartDom);
				var option;
				option = {
					title: {
						text: '经营曲线',
						textStyle: {
							color: "#00A292",
							fontSize: 14,
							fontStyle: 'normal',
							fontWeight: '',
						}
					},
					tooltip: {
						trigger: 'axis'
					},
					legend: {
						data: ['订单量', '订单金额']
					},
					grid: {
						left: '3%',
						right: '4%',
						bottom: '3%',
						containLabel: true
					},
					toolbox: {
						feature: {
							// saveAsImage: {}
						}
					},
					xAxis: {
						type: 'category',
						boundaryGap: false, //是否从原点开始
						data: submitDateArr
					},
					yAxis: {
						type: 'value'
					},
					series: [{
							name: '订单量',
							type: 'line',
							smooth: true, //数据是否平滑连接
							data: orderCountArr
						},
						{
							name: '订单金额',
							type: 'line',
							smooth: true, //数据是否平滑连接
							data: orderAmountArr
						}
					]
				};
				option && myChart.setOption(option);
			},
		}
	}
</script>

<style scoped>
	
	.col{
		display: flex;
		flex-direction: column;
	}
	.chart {
		width: 100%;
		height: 360px;
	}

	.title {
		font-size: 14px;
		color: var(--theme-color);
	}

	.name {
		font-size: 14px;
		color: #767676;
		margin-top: 10px;
	}

    .picker {
		margin-left: 13px;
	}

	.dec {
		font-size: 24px;
		color: #000;
	}

	.item {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		padding: 20px 0;
	}
	
	.screen_div {
		display: flex;
		flex-direction: row;
		width: 100%;
		height: auto;
		margin-top: 20px;
	}
	
	.select {
		width: 140px;
		margin-right: 13px;
	}
	
	.table_div {
		width: 100%;
		margin: 20px 0;
	}
	
	.table_div::before {
		height: 0px;
	}
</style>